"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timezone = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var date_1 = require("../../utils/date/date");
function Timezone() {
    var _a;
    var t = (0, react_i18next_1.useTranslation)().t;
    var timeZone = (0, date_1.getUserTimezone)();
    return (react_1.default.createElement("i", { className: "eva-timezone-icon implioicons-globe", title: (_a = t('DASHBOARD.STATISTICS.TIMEZONE_TOOLTIP_R18N', { timeZone: timeZone })) !== null && _a !== void 0 ? _a : '' }));
}
exports.Timezone = Timezone;
